import React, { useState } from "react";
import vehicleDamageReportStepImg from "../../../../assets/images/keyless-return/vehicle-damage-report-step-img.svg";
import icoInfoOrange from "../../../../assets/images/ico-info-orange.svg";
import icoCheckGreen from "../../../../assets/images/ico-check-green.svg";
import icoArrowDown from "../../../../assets/images/ico-arrow-down.svg";


export function VehicleDamageReportStep2({ onAdd, damageData = {}, initialExpandedPart, t }) {
  const vehicleParts = [
    "Left Side",
    "Right Side",
    "Front",
    "Rear",
    "Top | Roof",
  ];

  const vehiclePartsLabels = {
    "Left Side": t("keylessReturnLeftSide"),
    "Right Side": t("keylessReturnRightSide"),
    "Front": t("keylessReturnFront"),
    "Rear": t("keylessReturnRear"),
    "Top | Roof": t("keylessReturnTopRoof"),
  };

  const initialIndex = initialExpandedPart
    ? vehicleParts.indexOf(initialExpandedPart)
    : null;
  const [expandedIndex, setExpandedIndex] = useState(
    initialIndex !== -1 ? initialIndex : null
  );

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
        gap: "16px",
      }}
    >

      <img
        src={vehicleDamageReportStepImg}
        alt="Verificação do estado do veículo"
        className="return-image"
      />

      <p
        style={{
          fontSize: "14px",
          color: "#333",
          margin: 0,
          lineHeight: "1.4",
        }}
      >
        {t("keylessReturnDamageSubmit")}
      </p>

      {/* Legenda de status */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "16px",
          fontSize: "10px",
          fontWeight: "bold",
          color: "#333",
          marginTop: "4px",
          marginBottom: "8px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <img src={icoCheckGreen} alt="Ícone check verde" style={{ width: "14px", height: "14px" }} />
          <span>{t("keylessReturnNoDamages")}</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <img src={icoInfoOrange} alt="Ícone exclamação laranja" style={{ width: "14px", height: "14px" }} />
          <span>{t("keylessReturnDamagesReported")}</span>
        </div>
      </div>

      <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "8px" }}>
        {vehicleParts.map((part, index) => (
          <div key={index} style={{ display: "flex", flexDirection: "column" }}>
            <div
              onClick={() => handleToggle(index)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px 16px",
                border: "1px solid #E0E0E0",
                borderRadius: expandedIndex === index ? "8px 8px 0 0" : "8px",
                backgroundColor: "#FFFFFF",
                boxShadow: "0 2px 4px rgba(0,0,0,0.03)",
                cursor: "pointer",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <img
                  src={icoArrowDown}
                  alt="Seta para baixo"
                  style={{
                    width: "16px",
                    height: "16px",
                    transform: expandedIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s ease",
                  }}
                />
                <span style={{ fontSize: "14px", fontWeight: "bold", color: "#333" }}>
                  {vehiclePartsLabels[part] || part}
                </span>
              </div>
              <img
                src={damageData[part]?.photos?.length ? icoInfoOrange : icoCheckGreen}
                alt="Status"
                style={{ width: "18px", height: "18px" }}
              />
            </div>

            {expandedIndex === index && (
              <div
                style={{
                  padding: "12px 16px",
                  border: "1px solid #E0E0E0",
                  borderTop: "none",
                  borderRadius: "0 0 8px 8px",
                  backgroundColor: "#F9F9F9",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {damageData[part]?.notes && (
                  <p style={{ margin: 0, fontSize: "12px", color: "#555", textAlign: "left" }}>
                    {damageData[part].notes}
                  </p>
                )}

                {damageData[part]?.photos?.length > 0 && (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "8px",
                    }}
                  >
                    {damageData[part].photos.map((photo, i) => (
                      <div
                        key={photo.id || i}
                        style={{
                          borderRadius: "6px",
                          overflow: "hidden",
                          border: "1px solid #E0E0E0",
                          aspectRatio: "16/9",
                        }}
                      >
                        <img
                          src={photo.url || photo.dataUrl}
                          alt={`Dano ${i + 1}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}

                <button
                  onClick={() => onAdd(part)}
                  style={{
                    backgroundColor: "#30303099",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    padding: "6px 0",
                    width: "50%",
                    fontSize: "14px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  {t("keylessReturnAddDamage")}
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
